import { useMemo } from 'react';
import { Container } from "@mui/material"
import { Login } from "components/Login"
import { useLocation } from 'react-router-dom';

const getSafeRedirectPath = (fromLocation) => {
	const pathname = fromLocation?.pathname || '/';
	const search = fromLocation?.search || '';
	const hash = fromLocation?.hash || '';

	if (!pathname.startsWith('/')) {
		return '/';
	}

	if (pathname === '/signin' || pathname === '/authorize' || pathname === '/callback') {
		return '/';
	}

	return `${pathname}${search}${hash}`;
};

const SignIn = () => {
	const location = useLocation();
	const redirectTo = useMemo(() => getSafeRedirectPath(location.state?.from), [location.state]);

	return (
		<>
			<Container
				sx={{
					display: 'flex',
					height: '100vh',
					justifyContent: 'center',
					alignItems: 'center',
					flexGrow: 1,
				}}
			>
				<Login redirect={redirectTo} />
			</Container>
		</>
	)
}

export { SignIn }